require('./command.js');

PegasusTemplate.EditBlockRegionImageCommand = PegasusTemplate.Command.extend({
  description: function(){
    return Em.I18n.t('command_descriptions.changed_email_background');
  }.property(),
  executeColor:null,
  unexecuteColor:null,

  executeImage:null,
  unexecuteImage:null,

  execute: function(){
    PegasusTemplate.lookupController('toolbar').setProperties({
      selectedBlockRegionImage: this.get('executeImage'),
      selectedBlockRegionColor: this.get('executeColor'),
      selectedBlockRegionImageCovers: this.get('executeStyle')
    });
    this._super();
  },
  unexecute: function(){
    PegasusTemplate.lookupController('toolbar').setProperties({
      selectedBlockRegionImage: this.get('unexecuteImage'),
      selectedBlockRegionColor: this.get('unexecuteColor'),
      selectedBlockRegionImageCovers: this.get('unexecuteStyle')
    });
    this._super();
  }
});

